import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMappedState } from 'redux-react-hook';
import { GUEST_ROUTES } from 'routes/routes';
import styled from 'styled-components';

import AuthForm from '../auth/tools/AuthForm';
import PublicGamesListTool from '../games/tools/PublicGamesListTool';
import NiceModal from '../modals/NiceModal';
import SubscriptionModal from '../modals/SubscriptionModal';
import UserTemplate from '../templates/UserTemplate/UserTemplate';

export default function AllRoleplaysApp() {
  const { isSignedIn } = useMappedState(
    useCallback(state => {
      const isSignedIn = state.users.currentUserId != undefined;
      return {
        isSignedIn: isSignedIn
      };
    }, [])
  );
  const navigate = useNavigate();

  const [subscriptionModalState, setSubscriptionModalState] = useState({
    isOpen: false,
    renderedForReason: undefined
  });
  const [authModalOpen, setAuthModalOpen] = useState(false);

  const handleCloseAuthModal = () => setAuthModalOpen(false);

  return (
    <UserTemplate currentName={'index'}>
      <PublicGamesListTool
        onItemClick={item => {
          if (item?.isLocked != true) {

            navigate(GUEST_ROUTES.ROLEPLAY(item.alias));
          } else {
            if (isSignedIn == true) {
              setSubscriptionModalState({
                isOpen: true,
                renderedForReason: 'premium_roleplay_click'
              });
            } else {
              setAuthModalOpen(true);
            }
          }
        }}
      />
      {subscriptionModalState.isOpen && (
        <SubscriptionModal
          analyticsData={{
            rendered_for_reason: subscriptionModalState.renderedForReason
          }}
          isOpen
          onClose={() => {
            setSubscriptionModalState({
              isOpen: false,
              renderedForReason: undefined
            });
          }}
        />
      )}

      {authModalOpen == false ? null : (
        <NiceModal
          onClose={handleCloseAuthModal}
        >
          <ModalInnerPlaceholder>
            <AuthForm onClose={handleCloseAuthModal} />
          </ModalInnerPlaceholder>
        </NiceModal>
      )}
    </UserTemplate>
  );
}

const ModalInnerPlaceholder = styled.div`
  width: 380px;
  padding: 30px;
  box-sizing: border-box;
  @media (max-width: 400px) {
    width: 100%;
    /* padding: 15px; */
  }
`;
